/*
 * @Author: wuxi
 * @Date: 2022-04-13 15:57:52
 * @LastEditors: wuxi
 * @LastEditTime: 2022-04-27 14:23:22
 * @FilePath: \csx-front-supply-chain\hooks\useGetFeatureStatus.js
 * @Description:
 *
 *
 */
import { useState, useEffect, useCallback } from 'react';
import { getData } from '@util';
import { API_POST_FEATURE_TOGGLE_STATUS } from '@api';
const env = process.env.NODE_ENV;
const envEnum = { dev: 1, sit: 2, pre: 3, production: 4, test: 1, development: 1 };

const useGetFeatureStatus = (switchKey, txProjectName = 'scc') => {
  //开关状态（0-关闭 1-开启 2-不存在）
  console.log('env------------', env);
  const [state, setState] = useState(2);
  const getStatus = useCallback(() => {
    getData({
      api: API_POST_FEATURE_TOGGLE_STATUS,
      data: { switchKey, txProjectName, env: envEnum[env] },
    })
      .then(({ data }) => {
        setState(data);
        // 请求成功存本地
        // localStorage.setItem(switchKey, data)
      })
      .catch(() => {
        // 请求失败 取上一下存到本地的当前switchKey状态
        // setState(Number(localStorage.getItem(switchKey)))
      });
    //页面卸载  删除本地存储
    // return () => {
    //   localStorage.removeItem(switchKey)
    // }
  }, [switchKey, txProjectName]);
  useEffect(getStatus, []);
  return state === 1 ? true : false;
};
export default useGetFeatureStatus;
